export default __webpack_public_path__ + "static/media/sorareBlueprintLogo-200.cbe32074.png";